import AuthApi from '@/api/auth'
import {
  FACEBOOK_CLIENT_ID,
  INSTAGRAM_CLIENT_ID,
  INSTAGRAM_REDIRECT_URL,
  INSTAGRAM_DIRECT_CLIENT_ID,
  INSTAGRAM_DIRECT_REDIRECT_URL,
  BASE_ROUTE_URL,
} from '@/constants/config'
import InstagramAccountsApi from '@/api/instagram/account'
import { notifyFlutterAppLoginSuccess, redirectToHomeIfInWebView } from '@/utils/flutter-webview'

const facebookScopes = ['email',
  'pages_show_list',
  'public_profile',
  'pages_messaging',
  'pages_manage_engagement',
  'pages_read_engagement',
  'pages_manage_posts',
  'pages_manage_metadata',
  'pages_read_user_content',
]
const instaScopes = [
  'pages_show_list',
  'instagram_basic',
  'instagram_manage_comments',
  'instagram_manage_insights',
  'instagram_content_publish',
  'pages_manage_metadata',
  'pages_messaging',
  'instagram_manage_messages',
]

const AuthMixin = {
  data() {
    return {
      error: null,
      loading: false,
    }
  },
  computed: {
    isMobile() {
      return true
    },
  },
  methods: {
    async authInstagram(redirect = true) {
      await this.authByCode(redirect, true)
    },
    async authInstagramDirect(redirect = true) {
      this.error = null
      this.loading = true
      this.$store.commit('auth/SET_LOADER', true)

      try {
        const appId = INSTAGRAM_DIRECT_CLIENT_ID || INSTAGRAM_CLIENT_ID
        const basePath = BASE_ROUTE_URL === '/' ? '' : BASE_ROUTE_URL.replace(/\/$/, '')
        let redirectUri = INSTAGRAM_DIRECT_REDIRECT_URL
        if (!redirectUri) {
          redirectUri = `${window.location.origin}${basePath}/auth/instagram/callback`
        }
        const encodedRedirectUri = encodeURIComponent(redirectUri)
        const scope = 'instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments,instagram_business_content_publish,instagram_business_manage_insights'

        if (this.isMobile) {
          // Full page redirect like authByCode (no popup)
          window.location.href = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${appId}&redirect_uri=${encodedRedirectUri}&response_type=code&scope=${encodeURIComponent(scope)}`
          return
        }

        // Desktop: Instagram OAuth popup
        const width = 600
        const height = 700
        const left = (window.screen.width / 2) - (width / 2)
        const top = (window.screen.height / 2) - (height / 2)

        const authUrl = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${appId}&redirect_uri=${encodedRedirectUri}&response_type=code&scope=${encodeURIComponent(scope)}`
        const popup = window.open(
          authUrl,
          'Instagram Login',
          `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no,directories=no,status=no`,
        )

        const checkPopup = setInterval(() => {
          if (popup.closed) {
            clearInterval(checkPopup)
            this.loading = false
            this.$store.commit('auth/SET_LOADER', false)
          }
        }, 1000)

        const messageListener = event => {
          if (event.origin !== window.location.origin) {
            return
          }

          if (event.data && event.data.type === 'instagram_oauth_callback') {
            window.removeEventListener('message', messageListener)
            clearInterval(checkPopup)
            if (!popup.closed) {
              popup.close()
            }

            if (event.data.code) {
              this.handleInstagramCallback(event.data.code, event.data.state, redirect)
            } else if (event.data.error) {
              this.$notifyError(this.$t('auth.fail-message'))
              this.error = event.data.error
              this.loading = false
              this.$store.commit('auth/SET_LOADER', false)
            }
          }
        }

        window.addEventListener('message', messageListener)
      } catch (e) {
        this.$notifyError(this.$t('auth.fail-message'))
        this.error = e.message || this.$t('auth.fail-message')
        this.loading = false
        this.$store.commit('auth/SET_LOADER', false)
      }
    },
    async handleInstagramCallback(code, state) {
      try {
        // Exchange code for access token
        const response = await AuthApi.loginByCode({
          code,
          state,
          instagram: 'yes',
          isDirectInstagram: true,
        })
        const accessToken = response?.access_token
        const userId = response?.user_id

        if (!accessToken) {
          this.$notifyError(this.$t('auth.fail-message'))
          return
        }

        // Use the access token to add Instagram account
        const accountData = { token: accessToken, isDirect: true }
        if (userId) {
          accountData.ig_user_id = userId
        }
        await this.addInstagramAccount(accountData)
      } catch (e) {
        this.$notifyError(this.$t('auth.fail-message'))
        this.error = e
      } finally {
        this.loading = false
        this.$store.commit('auth/SET_LOADER', false)
      }
    },
    async authFacebook(redirect = true) {
      await this.authByCode(redirect)
    },
    async authByCode(redirect, isInstagram = false) {
      if (this.isMobile) {
        const appId = isInstagram ? INSTAGRAM_CLIENT_ID : FACEBOOK_CLIENT_ID
        const redirectUri = encodeURIComponent(`https://${window.location.hostname}/auth/facebook/callback`)
        const scope = isInstagram ? instaScopes.join(',') : facebookScopes.join(',')
        let state = 'e7dbcf6b-637f-47b1' // CSRF protection
        if (redirect) state += '_login'
        if (isInstagram) state += '_insta'
        window.location.href = `
        https://www.facebook.com/v21.0/dialog/oauth?
        client_id=${appId}
        &redirect_uri=${redirectUri}
        &scope=${scope}
        &state=${state}
      `.replace(/\s/g, '')
      } else if (isInstagram) {
        this.hello.init({ facebook: INSTAGRAM_CLIENT_ID }, { redirect_uri: INSTAGRAM_REDIRECT_URL })
        await this.authSocial(instaScopes, redirect, ' instagram')
      } else {
        console.log('ddd')
        this.hello.init({ facebook: FACEBOOK_CLIENT_ID }, { redirect_uri: '/' })
        await this.authSocial(facebookScopes, redirect, 'facebook')
      }
    },
    async authSocial(scopes, redirect = true, type = 'facebook') {
      this.error = null
      this.loading = true
      this.$store.commit('auth/SET_LOADER', true)
      try {
        await this.hello('facebook').login({ scope: scopes })
          .then(async () => {
            const authRes = this.hello('facebook').getAuthResponse()
            if (type === 'facebook') {
              await this.login({ token: authRes.access_token }, redirect)
            } else {
              await this.addInstagramAccount({ token: authRes.access_token })
            }
          })
      } catch (e) {
        let msg = this.$t('auth.fail-message')
        if (e?.error?.code === 'cancelled') {
          msg = this.$t('auth.fail-message')
        }
        this.$notifyError(msg)
        this.error = msg
        this.loading = false
        this.$store.commit('auth/SET_LOADER', false)
      }
    },
    async addInstagramAccount(data) {
      InstagramAccountsApi.addAccount(data).then(res => {
        if (res.error === 0) {
          this.$store.commit('instagram/SET_INSTA_ACCOUNTS', res.accounts)
          notifyFlutterAppLoginSuccess()
          if (redirectToHomeIfInWebView(this.$router)) return
          this.$router.push({ name: 'owner:home' })
        } else {
          this.$notifyError(this.$t('auth.fail-message'))
        }
      }).catch(e => { this.error = e }).finally(() => {
        this.loading = false
        this.$store.commit('auth/SET_LOADER', false)
      })
    },
    async login(data, redirect = true) {
      const self = this
      AuthApi.loginFb(data, redirect).then(res => {
        if (res.access_token) {
          self.$store.dispatch('auth/PREPARE_USER', { ...res })
          notifyFlutterAppLoginSuccess()
          if (redirect) {
            if (redirectToHomeIfInWebView(self.$router)) return
            self.$router.push({ name: 'owner:home' })
          }
        } else {
          self.$notifyError(this.$t('auth.fail-message'))
        }
      }).catch(e => { this.error = e }).finally(() => {
        this.loading = false
        this.$store.commit('auth/SET_LOADER', false)
      })
    },
  },
}

export default AuthMixin
